var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTotalBookingLeft = function SvgTotalBookingLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 165 77"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC8B35",
    d: "M154.649 88.36a9.52 9.52 0 0 0 9.518-9.518 9.52 9.52 0 0 0-9.518-9.517c-5.256 0-9.518 4.26-9.518 9.517s4.262 9.518 9.518 9.518M4.76 12.195A4.102 4.102 0 1 0-1.04 6.393a4.102 4.102 0 0 0 5.802 5.802"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1CCFCE",
    d: "m-2.318 35.407 19.157-19.156a11 11 0 0 1 11.98-2.384 10.994 10.994 0 0 1 3.567 17.931l-8.728 8.728a4.825 4.825 0 1 0 6.824 6.824l1.897-1.895A9.92 9.92 0 1 1 46.41 59.488l-7.775 7.772a2.15 2.15 0 0 0 1.519 3.666 2.15 2.15 0 0 0 1.518-.629l18.959-18.96a8.583 8.583 0 0 1 14.65 6.067 8.58 8.58 0 0 1-2.514 6.067l-5.12 5.119a1.87 1.87 0 0 0 0 2.654 1.87 1.87 0 0 0 2.656 0l.423-.423a23 23 0 0 1 32.522 0l8.765 8.765H-30S-.613 37.113-2.318 35.407"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC95D",
    d: "M13.201.2a.685.685 0 0 1 .967 0l2.07 2.058a.684.684 0 1 1-.967.97l-2.07-2.06a.68.68 0 0 1 0-.968"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC95D",
    d: "M16.238.2a.68.68 0 0 1 0 .967l-2.06 2.063a.685.685 0 1 1-.968-.97L15.272.2a.685.685 0 0 1 .967 0M55.309 58.3a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m-2.15 59.428 30.196-30.197M30.68 96.436 57.747 69.37M-16.98 65.706 10.085 38.64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.221 58.372a4.778 4.778 0 1 0 0-9.555 4.778 4.778 0 0 0 0 9.555"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B959F",
    d: "M113.7 62.524a16.354 16.354 0 1 0-.023 32.708 16.354 16.354 0 0 0 .023-32.708m0 29.464a13.122 13.122 0 1 1 0-26.244 13.122 13.122 0 0 1 0 26.244M8.099 80.527c.33-.11 12.816-12.735 17.594-17.571a2.593 2.593 0 1 1 3.68 3.659l-3.925 3.924a1.3 1.3 0 0 0 .421 2.124 1.3 1.3 0 0 0 1.417-.283l1.635-1.635a2.84 2.84 0 0 1 4.021 0 2.843 2.843 0 0 1 0 4.02 1.21 1.21 0 0 0 0 1.706l4.602 4.6H7.69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFC95D",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m70.906 82.454 33.8-33.8M-20.517 100.789l33.798-33.8M92.275 68.582l6.59-6.59"
  })));
};
export default SvgTotalBookingLeft;